<template>
    <update-dialog
        headerTitle="修改联系电话"
        :showDialog="showDialog"
        :canUse="canUse"
        @close="showDialog = false"
        @confirm="confirm"
        @opened="$refs.elIpt.focus()">
        <el-input placeholder="请输入联系电话"
            :class="{ err: showErr }"
            :maxlength="11"
            :value="phone"
            ref="elIpt"
            @input="handleIpt"></el-input>
        <p class="err-msg" v-if="showErr">输入正确的手机号</p>
    </update-dialog>
</template>

<script>
import UpdateDialog from './update_dialog'
import { openMessage } from '@/utils/system.tsx'
import $fetch from '@/api'

export default {
    data() {
        return {
            showDialog: false,
            phone: '',
            showErr: false
        }
    },
    computed: {
        canUse() {
            if (this.phoneReg.test(this.phone)) {
                return true
            } else {
                return false
            }
        }
    },
    created() {
        this.phoneReg = /^1[3456789]\d{9}$/
    },
    methods: {
        open(options = {}) {
            this.phone = ''
            this.showDialog = true
        },

        handleIpt(val) {
            if (val.length === 11 && !this.phoneReg.test(val)) {
                this.showErr = true
            } else {
                this.showErr && (this.showErr = false)
            }
            val = val.replace(/[^\d]/g, '')
            this.phone = val
        },

        confirm(cb) {
            return $fetch.post({
                url: '/shop/editshopinfo',
                params: {
                    phone: this.phone
                }
            }).then(data => {
                this.showDialog = false
                openMessage('success', '修改成功')
                this.$emit('refresh-shop-info')
            }, e => openMessage('error', e.message || '修改失败'))
            .then(() => cb())
        }
    },
    components: {
        UpdateDialog
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
    padding: 0 8px;
}
.err {
    ::v-deep .el-input__inner {
        border: 1px solid #E51C23 !important;
    }
}
.err-msg {
    margin: 6px 0 0 8px;
    font-size: 12px;
    color: #E51C23;
}
</style>
